namespace GeniuzPOS.Lookups {
    export class LookupTxtColorColumns {
        static columnsKey = 'Lookups.LookupTxtColor';
    }
}
